{% block sw_extension_label_display %}
	<div class="sw-extension-store-label-display">
        {% block sw_extension_label_display_label %}
            <sw-extension-label
                v-for="item in labels"
                :key="item.label"
                :background-color="item.color"
            >
                {{ item.label }}
            </sw-extension-label>
        {% endblock %}
    </div>
{% endblock %}
